// @ts-nocheck
import type { ThemeColorMode, ThemeColorRef } from '../../types/binding';
import type { BindingContext } from '../binding/types';

export function resolveEffectiveThemePaletteMode(
  ref: Pick<ThemeColorRef, 'mode'>,
  context: BindingContext,
): 'light' | 'dark' {
  const mode: ThemeColorMode = ref.mode ?? context.themeColorMode ?? 'auto';
  if (mode === 'light') {
    return 'light';
  }
  if (mode === 'dark') {
    return 'dark';
  }
  const scheme = context.hostContext?.colorScheme;
  return scheme === 'dark' ? 'dark' : 'light';
}

export function resolveThemeColorFromContext(
  ref: ThemeColorRef,
  context: BindingContext,
): string | undefined {
  const paletteKey = resolveEffectiveThemePaletteMode(ref, context);
  return context.themeColorPalettes?.[paletteKey]?.[ref.key];
}
